document.addEventListener('DOMContentLoaded', function () {
  class YGSwiper extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
      this.getAllAttributes()
      this.initSwiper()
    }

    getAllAttributes() {
      let booleanAttrs = ['loop', 'pagination', 'navigation'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀
          
          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');
    
      console.log("pairs",pairs)
      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;
    
        const [slides, space] = values.split('-').map(Number);
    
        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      console.log("result",   result)
      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        loop: this['loop'],
        autoplay: this['autoplay']?{
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }:false,
        pagination: this['pagination']?{
          el: '.swiper-pagination',
          clickable: true,
        }:false,
        navigation: this['navigation']?{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }:false,
        breakpoints: this['breakpoints']?this['breakpoints']:false
      })
    }
  }
  if (!window.customElements.get('yg-swiper')) {
      window.customElements.define('yg-swiper', YGSwiper)
  }

  class YGPassword extends HTMLElement {
      constructor() {
          super()
      }

      get password() {
          return this.querySelector('input');
      }

      get showIcon() {
          return this.querySelector('.yg-password-show');
      }

      get hideIcon() {
          return this.querySelector('.yg-password-hide');
      }

      connectedCallback() {
        this.showIcon.addEventListener('click', () => {
          this.password.type = 'text';
          this.showIcon.style.display = 'none';
          this.hideIcon.style.display = 'block';
        });

        this.hideIcon.addEventListener('click', () => {
          this.password.type = 'password';
          this.showIcon.style.display = 'block';
          this.hideIcon.style.display = 'none';
        })
      }
  }
  if (!window.customElements.get('yg-password')) {
      window.customElements.define('yg-password', YGPassword)
  }
})